/* generated by pull.js */
const manifest = {
  editorOnly: true,
  name: 'Hex color picker',
  description: 'Adds hex code inputs to color pickers.',
  tags: ['recommended'],
  credits: [
    {
      name: 'Richie Bendall'
    },
    {
      name: 'apple502j'
    }
  ],
  userscripts: [
    {
      url: 'userscript.js'
    }
  ],
  userstyles: [
    {
      url: 'style.css'
    }
  ],
  dynamicDisable: true,
  enabledByDefault: true
};
export default manifest;
